import React from "react";
import Lozenge from "../accoutrements/lozenge";
import Author, { AuthorObject } from "./Contributors";
import { Typography } from "@material-tailwind/react";
import ContentContainer from "../containers/ContentContainer";
import { ContributorType } from "@/src/types";
import Contributors from "./Contributors";
import Link from "next/link";

export interface CategoriesObject {
  name: string;
  uri: string;
  slug: string;
}

export interface HeaderProps {
  categories: CategoriesObject[];
  title: string;
  subTitle: string;
  author: AuthorObject;
  date: string;
  contributors: ContributorType[];
}

const Header = ({
  categories = [],
  title,
  subTitle,
  author,
  date,
  contributors,
}: HeaderProps) => {
  return (
    <div className={"bg-slate-100"}>
      <ContentContainer>
        <div className={"mb-2 flex "}>
          <div className={"container flex flex-col mx-auto gap-y-4"}>
            <div className={"flex flex-row gap-2"}>
              {categories.map(function (category) {
                return (
                  <Link href={`${category.uri}`} key={category.uri}>
                    <Lozenge color="dark" text={category.name} />
                  </Link>
                );
              })}
            </div>
            {title && (
              <Typography variant="h2" className="font-bold">
                {title}
              </Typography>
            )}

            <p className="lg:w-[75%]">{subTitle}</p>
            <span className="font-light">
              {new Date(date).toLocaleDateString()}
            </span>
            <Contributors contributors={contributors} />
          </div>
        </div>
      </ContentContainer>
    </div>
  );
};

export default Header;
